import { render, staticRenderFns } from "./input-color-picker.vue?vue&type=template&id=064813d6&"
import script from "./input-color-picker.vue?vue&type=script&lang=js&"
export * from "./input-color-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports